import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import * as moment from 'moment-timezone';
import { ServiceLayer } from 'src/app/services/serviceLayer';
import { environment } from 'src/environments/environment';
import { timeZoneMappings } from '../mapper/TimeZoneMapper';

@Component({
  selector: 'app-notification-banner',
  templateUrl: './notification-banner.component.html',
  styleUrls: ['./notification-banner.component.css']
})
export class NotificationBannerComponent implements OnInit {
  public notification: any;
  public showMaintenanceMode: Boolean = false;
  public DisablePage: Boolean = false;
  @Output() IspageDisable = new EventEmitter<Boolean>();
  @Output() IsMaintenanceAlert = new EventEmitter<Boolean>();

  constructor( private serviceLayer: ServiceLayer) { }

  ngOnInit(): void {
    this.IspageDisable.emit(false);
    this.IsMaintenanceAlert.emit(false);


    let localTimeZoneId = moment.tz.guess();
    let dotNetTimeZoneId = timeZoneMappings[localTimeZoneId] || "Unknown";
    var loginDetails = JSON.parse(window.localStorage.getItem("loginUserDetails"));
    if (loginDetails?.accessToken) {
    let notificationMessage = this.serviceLayer.getNotifications(environment.Appcode,environment.environment,dotNetTimeZoneId); 
     
    notificationMessage.then((response) =>  {
      if (response?.length > 0) {
        this.notification = response;
        if (this.notification[0]?.message != null && this.notification[0]?.message != undefined) {
          if(Date.parse(this.notification[0]?.displayDateTime) <= new Date().getTime() && new Date().getTime() <= Date.parse(this.notification[0]?.startDateTime)){
            this.showMaintenanceMode = true;
            this.IsMaintenanceAlert.emit(true);

          }
          else if(new Date().getTime()>= Date.parse(this.notification[0]?.startDateTime) && new Date().getTime()<= Date.parse(this.notification[0]?.endDateTime))
          {
            this.DisablePage = true;
            this.IspageDisable.emit(true);

          }
        }
      }
    });
  }
    
    }
  }


